var map = {
	"./CO2ppm.png": "f3ac",
	"./HCHOmg.png": "0ced",
	"./HCHOppb.png": "a131",
	"./PM10mg.png": "bc16",
	"./PM10μg.png": "412a",
	"./PM2.5mg.png": "c421",
	"./PM2.5μg.png": "3b19",
	"./TVOCmg.png": "db14",
	"./TVOCppb.png": "4f91",
	"./aqi.png": "b286",
	"./ihai.png": "424f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3ee2";